import { Language } from 'models'

const language: Language = 'ps'

// Should not be changed:
export const config = {
  language: (new URLSearchParams(window.location.search).get('lang') ||
    process.env.REACT_APP_LANG ||
    language) as Language,
  linkEn: process.env.REACT_APP_LINK_EN,
  linkPs: process.env.REACT_APP_LINK_PS,
  linkPrs: process.env.REACT_APP_LINK_PRS,
}
